import { getUser } from '~src/user';

/**
 * Upload a Publisher/CorelDraw import file using the presigned URL endpoint.
 */
export const uploadPublisherImportFile = async (file) => {
  const { userToken } = await getUser();

  const presignResponse = await fetch(
    `${process.env.PARSE_SERVER_ENDPOINT}/functions/upload`,
    {
      method: 'post',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'x-parse-application-id': process.env.PARSE_APPLICATION_ID,
        'x-parse-session-token': userToken,
      },
      body: JSON.stringify({
        filename: file.name,
        contentType: file.type || 'application/octet-stream',
        collection: 'template-imports',
        bucket: 'default',
        dir: '',
      }),
    }
  );

  const presignData = await presignResponse.json();

  if (!presignData.result || !presignData.result.url) {
    throw new Error('Impossibile ottenere URL per il caricamento');
  }

  const uploadResponse = await fetch(presignData.result.url, {
    method: presignData.result.method,
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });

  if (!uploadResponse.ok) {
    throw new Error('Upload fallito');
  }

  const s3Url = new URL(presignData.result.url);
  const s3Key = s3Url.pathname.replace(/^\//, '');
  return `${process.env.EDGE_RESIZER}/${s3Key}`;
};
